"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionReviewStepDefinitions = exports.ExceptionReviewPlane = void 0;
const z = require("zod");
const apply_signal_consolidation_map_1 = require("../../../../Consensus/general-slices/apply-signal-consolidation-map");
const apply_mode_consolidation_map_1 = require("../../../../Consensus/general-slices/apply-mode-consolidation-map");
const exception_review_types_1 = require("./exception-review.types");
var ExceptionReviewPlane;
(function (ExceptionReviewPlane) {
    ExceptionReviewPlane["Form"] = "form";
    ExceptionReviewPlane["General"] = "general";
})(ExceptionReviewPlane || (exports.ExceptionReviewPlane = ExceptionReviewPlane = {}));
exports.ExceptionReviewStepDefinitions = {
    ExceptionReviewSigmaModel: {
        type: 'ExceptionReviewSigmaModel',
        displayName: 'Exception review: sigma model',
        inputSchema: z.object({
            consensusRunId: z.string(),
            packageId: z.string(),
            proposedSigmaModelType: z.string(),
            proposedElementSigmaModelType: z.string(),
            sigmaModelContested: z.boolean(),
            sigmaModelReviewItems: exception_review_types_1.SlicedReviewItemSchema.array(),
            mixedCohort: z.boolean().default(false),
            defaultPlane: z.nativeEnum(ExceptionReviewPlane).default(ExceptionReviewPlane.Form),
        }),
        outputSchema: z.object({
            resolvedSigmaModelType: z.string().min(1, 'resolvedSigmaModelType is required'),
            resolvedElementSigmaModelType: z.string(),
            resolvedPlane: z.nativeEnum(ExceptionReviewPlane).default(ExceptionReviewPlane.Form),
            decisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
    },
    ExceptionReviewSignalConsolidation: {
        type: 'ExceptionReviewSignalConsolidation',
        displayName: 'Exception review: signal consolidation',
        inputSchema: z.object({
            consensusRunId: z.string(),
            packageId: z.string(),
            resolvedSigmaModelType: z.string(),
            resolvedElementSigmaModelType: z.string(),
            precedingDecisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
        outputSchema: z.object({
            signalMap: apply_signal_consolidation_map_1.SignalConsolidationEntrySchema.array(),
            decisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
    },
    ExceptionReviewModeConsolidation: {
        type: 'ExceptionReviewModeConsolidation',
        displayName: 'Exception review: modes',
        inputSchema: z.object({
            consensusRunId: z.string(),
            packageId: z.string(),
            precedingDecisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
        outputSchema: z.object({
            modeMap: apply_mode_consolidation_map_1.ModeConsolidationEntrySchema.array(),
            decisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
    },
    ExceptionReviewValues: {
        type: 'ExceptionReviewValues',
        displayName: 'Exception review: values',
        inputSchema: z.object({
            consensusRunId: z.string(),
            packageId: z.string(),
            sliceKeys: z.string().array(),
            resolvedSigmaModelType: z.string(),
            resolvedElementSigmaModelType: z.string(),
            completesReview: z.boolean(),
            precedingDecisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
        outputSchema: z.object({
            decisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
    },
    ExceptionReviewPublishConfirm: {
        type: 'ExceptionReviewPublishConfirm',
        displayName: 'Exception review: confirm',
        inputSchema: z.object({
            consensusRunId: z.string(),
            packageId: z.string(),
            completesReview: z.boolean(),
            precedingDecisions: exception_review_types_1.ExceptionReviewDecisionSchema.array(),
        }),
        outputSchema: z.object({
            allowOverwritePublished: z.boolean(),
        }),
    },
};
//# sourceMappingURL=exception-review-steps.js.map